import { Box, CircularProgress, Typography } from "@mui/material";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import * as pdfjsLib from "pdfjs-dist";

const PdfViewer = ({
  base64Data,
  fileType,
  isPdfFileLoading,
  ZoomInButton,
  ZoomOutButton,
  ZoomPopover,
  searchPluginInstance,
  thumbnailPluginInstance,
  zoomPluginInstance,
}) => {
  return (
    <Box
      sx={{
        width: "55%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {isPdfFileLoading ? (
        <Box
          sx={{
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255,255,255,0.8)",
            zIndex: 10,
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : fileType === "application/pdf" && base64Data ? (
        <div
          className="rpv-core__viewer"
          style={{
            border: "1px solid rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              alignItems: "center",
              backgroundColor: "#eeeeee",
              borderBottom: "1px solid rgba(0,0,0,0.1)",
              display: "flex",
              justifyContent: "center",
              padding: "4px",
            }}
          >
            <ZoomOutButton />
            <ZoomPopover />
            <ZoomInButton />
          </div>
          <div style={{ flex: 1, overflow: "hidden" }}>
            <Worker workerUrl={pdfjsLib.GlobalWorkerOptions.workerSrc}>
              <Viewer
                fileUrl={`data:${fileType};base64,${base64Data}`}
                plugins={[
                  searchPluginInstance,
                  thumbnailPluginInstance,
                  zoomPluginInstance,
                ]}
              />
            </Worker>
          </div>
        </div>
      ) : fileType?.startsWith("image/") && base64Data ? (
        <img
          src={`data:${fileType};base64,${base64Data}`}
          alt={fileType}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            border: "1px solid rgba(0,0,0,0.3)",
          }}
        />
      ) : (
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            fontSize: "1.2rem",
            color: "gray",
          }}
        >
          File Not Available
        </Typography>
      )}
    </Box>
  );
};

export default PdfViewer;
